import * as React from 'react';
import classnames from 'classnames';

import GalleryModalAsset from 'components/gallery-modal/gallery-modal-asset/GalleryModalAsset';

import { expandDataProps } from 'utils/helper/common';

import type { Data, GalleryModalItem } from 'types';

import type { SyntheticEvent } from 'react';

type OverlayTitle = {
  value: string,
  show: boolean
};

type Props = {
  title: OverlayTitle | undefined | null,
  body: React.ReactNode | undefined | null,
  selectedItem: GalleryModalItem,
  currentPosition: number,
  onClick?: (a: SyntheticEvent<HTMLElement>) => void,
  data?: Data
};

class ContentApprovalGalleryModalAssetWithOverlay extends React.PureComponent<Props> {
  static defaultProps = {
    title: null,
    body: null
  };

  renderTitle(value: string): React.ReactNode {
    return (
      <div className="content-approval-gallery-modal-asset-with-overlay__title">
        {value}
      </div>
    );
  }

  renderOverlay(): React.ReactNode {
    const { title, body, onClick } = this.props;

    const bodyClasses = classnames('content-approval-gallery-modal-asset-with-overlay__body', {
      'content-approval-gallery-modal-asset-with-overlay__body--clickable': onClick
    });

    return (
      <React.Fragment>
        {
          title && title.show && title.value &&
            this.renderTitle(title.value)
        }
        {
          body && (
            <div className={bodyClasses}>
              {body}
            </div>
          )
        }
      </React.Fragment>
    );
  }

  renderMainAsset(): React.ReactNode {
    const { selectedItem, currentPosition } = this.props;

    return (
      <GalleryModalAsset
        selectedItem={selectedItem}
        currentPosition={currentPosition}
      />
    );
  }

  render(): React.ReactNode {
    const { data, onClick } = this.props;

    return (
      <div
        className="content-approval-gallery-modal-asset-with-overlay"
        onClick={onClick}
        {...expandDataProps(data)}
      >
        {this.renderMainAsset()}
        {this.renderOverlay()}
      </div>
    );
  }
}

export default ContentApprovalGalleryModalAssetWithOverlay;
